export const KEYS = {
  TRADERS_NEW: "/traders/new",
  TRADERS_ALL: "/traders/all",
  TRADERS_DETAIL: (address: string) => `/traders/${address}`,
  TRADERS_TOTAL: "/traders/total",
  // REFERRALS_SUMMARY: (address: string) => `/referrals/${address}`,
  REFERRALS_SUMMARY: (address: string) => `/referrals/v2/${address}`,
  REFERRALS_CODES: (address: string) => `/referrals/${address}/codes`,
  REFERRALS_CODE_LOOKUP: (code: string) => `/referrals/code/${code}`,
  REFERRALS_CODES_OWNERS: "/referrals/codes/owners",
  REFERRALS_STATS: "/referrals/stats",
};
